import { render, staticRenderFns } from "./NotificacaoModal.vue?vue&type=template&id=95f23204&"
import script from "./NotificacaoModal.vue?vue&type=script&lang=js&"
export * from "./NotificacaoModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports